import { render, staticRenderFns } from "./B201.vue?vue&type=template&id=c49a93ae&scoped=true"
import script from "./B201.vue?vue&type=script&lang=js"
export * from "./B201.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Cy.css?vue&type=style&index=0&id=c49a93ae&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49a93ae",
  null
  
)

export default component.exports